var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('p',{staticClass:"logo"},[_vm._v("まいにちエコチェッカー")])]),_c('v-row',{staticClass:"sub-title",attrs:{"justify":"center"}},[_vm._v("Produced by Innoqua")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }